import React from "react";
import { connect } from "react-redux";
import { MainTaskContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import { MdAdd, MdAssignmentAdd } from "react-icons/md";
import moment from "moment";
import momentTZ from "moment-timezone";
import * as XLSX from "xlsx";
import queryString from "query-string";
import { SERVICES_TASK_RENDER_TYPE } from "utils/functions/serviceTask";
import { Buttons, Inputs, Displays, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class MainTaskContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    scrollToTopPageFN();
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_MAIN_TASK_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        // data: MOCKUP_DATA,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
          total: res.data.totalDocs,
          per_page: res.data.limit,
        },
        isLoading: false,
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handleClickCreate = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.SERVICE_TASK}/${e}`);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoading: true,
    });
    this.props.router.navigate(`${ROUTE_PATH.SERVICE_TASK}${joinQuery}`);
    this.fetchData(joinQuery);
  };

  handleClickAction = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.SERVICE_TASK}/action/${e}`);
  };

  handleExport = async () => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false`
      : `?pagination=false`;
    let res = await portalService.GET_MAIN_TASK_LIST(joinQuery);
    if (res && res.status === 200) {
      let wb = XLSX.utils.book_new();
      let ws_name = "SheetJS";

      let ws_data = res.data.docs.reduce((result, e, i) => {
        result.push([
          momentTZ(e.created_at).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
          e.latest_sub_task?.appointment_date
            ? momentTZ(e.latest_sub_task.appointment_date)
                .tz("Asia/Bangkok")
                .format("DD/MM/YYYY") +
              (e.latest_sub_task.appointment_time
                ? ` ${e.latest_sub_task.appointment_time}`
                : "")
            : "-",
          e.main_task_code || "-",
          SERVICES_TASK_RENDER_TYPE(e.warranty_type) || "-",
          e.sub_task_count ?? "-",
          e.latest_sub_task?.sub_task_code || "-",
          e.latest_sub_task?.is_call_confirm ? "Yes" : "-",
          e.latest_sub_task?.is_service_complete ? "Yes" : "-",
          e.latest_sub_task?.next_call_date
            ? momentTZ(e.latest_sub_task.next_call_date)
                .tz("Asia/Bangkok")
                .format("DD/MM/YYYY")
            : "-",
        ]);
        return result;
      }, []);

      ws_data.unshift([
        "Create Date",
        "Appointment date",
        "Main Task",
        "Type of product",
        "Number of Sub Task",
        "Latest Sub Task",
        "Call confirmed",
        "Service Completed",
        "Next call - Follow up",
      ]);

      let ws = XLSX.utils.aoa_to_sheet(ws_data);

      let wscols = [
        { wch: 20 },
        { wch: 25 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 15 },
        { wch: 20 },
        { wch: 25 },
      ];
      ws["!cols"] = wscols;

      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `services-task-report-${moment()
          .tz("Asia/Bangkok")
          .format("DD-MM-YYYY")}.xlsx`
      );

      this.setState({
        isBgLoading: false,
      });
    }
  };

  render() {
    const { authenRedux, router } = this.props;
    const { isLoading, isBgLoading, pagination, data } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "reward");
    return (
      <MainTaskContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {permission && permission.is_create && (
          <div className="btn_create">
            <div className="w120">
              <Buttons.BgIconPrefix
                label="New"
                icon={<MdAdd size={18} />}
                onClick={() => this.handleClickCreate("create")}
              />
            </div>
          </div>
        )}
        <Inputs.InputFilter
          theme_standard_input_filter
          dataFilter={dataFilter(router.location?.search)}
          btnLabel="ค้นหา"
          onQueryFilter={this.handleFilterKeyword}
          onExport={
            permission &&
            (permission.is_export || permission.is_export_condition)
              ? () => this.handleExport(permission)
              : false
          }
        />
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <>
            <div className="body_table  ">
              <Tables.Standard
                columns={columns({
                  handleClickDetail: this.handleClickCreate,
                  handleClickAction: this.handleClickAction,
                })}
                data={data}
                showPagination
                pagination={pagination}
                handlePageClick={this.handlePageClick}
                onChangePerPage={this.handlePerPageChange}
              />
            </div>
          </>
        )}
      </MainTaskContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "main_task_code",
      length: "311px",
      filter: {
        fieldQuery: "main_task_code",
        defaultValue: initialValues["main_task_code"],
        type: "text",
        label: "Main Task",
        placeholder: "Main Task",
      },
    },
    {
      accessor: "sub-task-code",
      length: "311px",
      filter: {
        fieldQuery: "sub-task-code",
        defaultValue: initialValues["sub-task-code"],
        type: "text",
        label: "Latest of Subtask",
        placeholder: "Latest of Subtask",
      },
    },
    {
      accessor: "warranty_type",
      length: "311px",
      filter: {
        fieldQuery: "warranty_type",
        defaultValue: initialValues["warranty_type"],
        type: "dropdown",
        label: "Type of Product",
        placeholder: "All",
        options: [
          {
            label: "In Warranty",
            value: "1",
          },
          {
            label: "No Warranty",
            value: "2",
          },
        ],
      },
    },
    {
      accessor: "sub-task-status",
      length: "311px",
      filter: {
        fieldQuery: "sub-task-status",
        defaultValue: initialValues["sub-task-status"],
        type: "dropdown",
        label: "Status",
        placeholder: "All",
        options: [
          {
            label: "Service InCompleted",
            value: "1",
          },
          {
            label: "Service Completed",
            value: "2",
          },
        ],
      },
    },
    {
      accessor: "preset",
      length: "311px",
      filter: {
        fieldQuery: "preset",
        defaultValue: initialValues["preset"],
        type: "dropdown",
        label: "Preset Search",
        placeholder: "All",
        options: [
          {
            label: "Call confirm today (1 วันก่อนวันนัด)",
            value: "1",
          },
          {
            label: "Appointmnet Today",
            value: "2",
          },
          {
            label: "Appointmnet Next 7 days",
            value: "3",
          },
          {
            label: "Call - Follow up 150 days or 5 Months",
            value: "4",
          },
        ],
      },
    },
  ];
};

const columns = ({ handleClickDetail, handleClickAction }) => [
  {
    Header: <div style={{ textAlign: "left" }}>Create Date</div>,
    accessor: "created_at",
    Cell: (props) =>
      momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Appointment date</div>,
    accessor: "latest_sub_task.appointment_date",
    Cell: (props) =>
      !props.value
        ? "-"
        : momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY") +
          ` ${props.row.original.latest_sub_task.appointment_time}`,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Main Task</div>,
    accessor: "main_task_code",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Type of product</div>,
    accessor: "warranty_type",
    Cell: (props) => SERVICES_TASK_RENDER_TYPE(props.value),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Number of Sub Task</div>,
    accessor: "sub_task_count",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Latest Sub Task</div>,
    accessor: "latest_sub_task.sub_task_code",
    Cell: (props) => props.value || "-",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Call confirmed</div>,
    accessor: "latest_sub_task.is_call_confirm",
    Cell: (props) => (props.value ? "Yes" : "-"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Service Completed</div>,
    accessor: "latest_sub_task.is_service_complete",
    Cell: (props) => (props.value ? "Yes" : "-"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Next call - Follow up</div>,
    accessor: "latest_sub_task.next_call_date",
    Cell: (props) =>
      !props.value
        ? "-"
        : momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>View</div>,
    accessor: "view",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        <MdAssignmentAdd size={22} color="#75D317" />
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Edit/Action</div>,
    accessor: "edit",
    Cell: (props) => (
      <div onClick={() => handleClickAction(props.row.original._id)}>
        <MdAssignmentAdd size={22} color="#F89900" />
      </div>
    ),
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MainTaskContainer));
